var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{attrs:{"value":_vm.value,"color":_vm.color,"height":_vm.small ? 16 : 36},scopedSlots:_vm._u([{key:"default",fn:function({ value }){return [_c('strong',{class:_vm.small ? '' : 'title'},[_vm._v(_vm._s(Math.ceil(value))+"%")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }